import { Button, OverlayTrigger, Popover } from 'react-bootstrap'
import { Placement } from 'react-bootstrap/esm/Overlay'
import { OverlayTriggerType } from 'react-bootstrap/esm/OverlayTrigger'
import './styles.scss'

export interface ToolTipOverlayProps {
  toolTipText: string
  placement?: Placement
  trigger?: OverlayTriggerType | OverlayTriggerType[]
}

const getToolTipText = (toolTipText: string): JSX.Element => {
  return (
    <Popover id='popover-jsonform' className='popover-jsonform'>
      <Popover.Content>
        <span data-testid='popover-tooltip-text'>{toolTipText}</span>
      </Popover.Content>
    </Popover>
  )
}

const ToolTipOverlayComponent: React.FC<ToolTipOverlayProps> = (
  props: ToolTipOverlayProps
) => {
  return (
    <OverlayTrigger
      placement={props.placement || 'auto'}
      overlay={getToolTipText(props.toolTipText)}
      trigger={props.trigger}
      popperConfig={{
        modifiers: [{ name: 'offset', options: { offset: [0, 30] } }]
      }}
      rootClose
      data-testid='overlay-trigger'
    >
      <Button
        variant='link'
        style={{ boxShadow: 'none' }}
        data-testid='popover-link'
      >
        <span className='mdi mdi-help-circle-outline popover-link' />
      </Button>
    </OverlayTrigger>
  )
}

export default ToolTipOverlayComponent
